import { toggleButtonProps, ToggleButton } from './chunk-X4HT4ZZN.js';
import { Icon } from './chunk-3QHO3DXX.js';
import { setARIALabel } from './chunk-Z6A4GYXE.js';
import { useMedia } from './chunk-ZIBTY3GT.js';
import { $$_create_component } from 'maverick.js/dom';
import { defineElement } from 'maverick.js/element';
import { playPaths, replayPaths, pausePaths } from 'media-icons';

var PlayButton = class extends ToggleButton {
  constructor() {
    super(...arguments);
    this.la = "togglePaused";
  }
  onAttach(el) {
    this.a = useMedia();
    this.u = this.U.bind(this);
    super.onAttach(el);
    setARIALabel(el, this.F.bind(this));
    const { paused, ended } = this.a.$store;
    this.setAttributes({
      "data-paused": paused,
      "data-ended": ended
    });
  }
  G(event) {
    const remote = this.a.remote;
    this.u() ? remote.pause(event) : remote.play(event);
  }
  U() {
    const { paused } = this.a.$store;
    return !paused();
  }
  F() {
    const { paused } = this.a.$store;
    return paused() ? "Play" : "Pause";
  }
  render() {
    return [
      $$_create_component(Icon, { paths: playPaths, slot: "play" }),
      $$_create_component(Icon, { paths: replayPaths, slot: "replay" }),
      $$_create_component(Icon, { paths: pausePaths, slot: "pause" })
    ];
  }
};
PlayButton.el = defineElement({
  tagName: "media-play-button",
  props: toggleButtonProps
});

export { PlayButton };
